import React from "react";
import styled from "styled-components";
import "../../styles/Snapshot.scss";
import { getNavigatorLanguage } from "../../services/Utils";
import { device } from "./breaks";
import { XSText } from "./textStyle";
import { Phrase } from "../Phrase";

const innerHeight = Math.max(window.innerWidth, window.innerHeight);
const innerWidth = Math.min(window.innerWidth, window.innerHeight);
const heightLeft = ({ editHeaderHeight = 20, editOptions = 27, printButton = 12 }) => innerHeight * (100 - editHeaderHeight - editOptions - printButton) * 0.01;
const editContainerHeight = (d) => (heightLeft({ ...d }) < innerWidth ? heightLeft({ ...d }) : innerWidth);

export const EditHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-content: flex-end;
  align-items: flex-end;
  width: 100%;
  height: ${({ disableActions }) => (disableActions ? "10%" : "18%")};
`;

export const ActionBtnStyle = styled.div`
  width: 50px;
  z-index: 501;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-highlight: none;
`;

export const CloseBtnStyle = styled.div`
  display: flex;
  ${({ position = "left" }) => (position === "left" ? `justify-content: flex-start;` : `justify-content: flex-end;`)};
  padding: 16px;
`;

export function CloseBtn(props) {
  const { color, position, onClick } = props;

  return (
    <CloseBtnStyle position={position} onClick={onClick}>
      <svg color={color} width="17" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.0118 16.759L0.341064 1.99987C-0.113769 1.5423 -0.113769 0.800764 0.341064 0.343202C0.795898 -0.11436 1.53302 -0.11436 1.98785 0.343202L16.659 15.1023C17.1138 15.5599 17.1138 16.3014 16.659 16.759C16.2041 17.2165 15.4667 17.2165 15.0118 16.759Z"
          fill="currentColor"
        />
        <path
          d="M0.341064 15.1034L15.0118 0.344667C15.4667 -0.112895 16.2038 -0.112895 16.6586 0.344667C17.1135 0.802229 17.1135 1.54377 16.6586 2.00133L1.9875 16.7601C1.53302 17.2177 0.795546 17.2177 0.341064 16.7601C-0.11377 16.3029 -0.11377 15.561 0.341064 15.1034Z"
          fill="currentColor"
        />
      </svg>
    </CloseBtnStyle>
  );
}

export const TextEditBtnStyle = styled.div`
  grid-area: headerRight;
  position: relative;
  padding: 15px;
  align-self: flex-end;
  stroke: ${(props) => (props.colors ? props.colors.generalTextColor : "#E86161")} svg {
    @media ${device.mobileS} {
      max-width: 28px;
    }
    @media ${device.mobileM} {
      max-width: 32px;
    }
    @media ${device.mobileL} {
      max-width: 32px;
    }
  }
`;

export const EditOptionsContainer = styled.div`
  min-height: ${() => window.innerHeight * 0.27}px;
  max-height: max-content;
  padding: 0 2em;
  display: flex;
  align-items: center;

  @media ${device.mobileXS} {
    zoom: 0.8;
  }
`;

export const TextEditBtnOK = (props) => {
  return (
    <TextEditBtnStyle colors={props.colors} onClick={props.onClick}>
      <svg viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 13.3636L11.75 22L31 3" strokeWidth="3" strokeLinecap="square" />
      </svg>
    </TextEditBtnStyle>
  );
};

export const TextEditBtnCancel = (props) => {
  return (
    <TextEditBtnStyle colors={props.colors} onClick={props.onClick}>
      <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.427 22.6577L0.441453 3.55785C-0.147151 2.96572 -0.147151 2.00608 0.441453 1.41395C1.03006 0.821815 1.98397 0.821815 2.57257 1.41395L21.5586 20.5138C22.1472 21.106 22.1472 22.0656 21.5586 22.6577C20.97 23.2499 20.0156 23.2499 19.427 22.6577Z"
          fill="#E86161"
        />
        <path
          d="M0.441453 20.5153L19.427 1.41584C20.0156 0.823707 20.9695 0.823707 21.5581 1.41584C22.1467 2.00798 22.1467 2.96761 21.5581 3.55975L2.57212 22.6592C1.98397 23.2513 1.0296 23.2513 0.441453 22.6592C-0.147151 22.0675 -0.147151 21.1074 0.441453 20.5153Z"
          fill="#E86161"
        />
      </svg>
    </TextEditBtnStyle>
  );
};

export const CameraBackWrapper = styled.div`
  display: flex;
  flex: 3.5;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const CameraBack = (props) => {
  return (
    <CameraBackStyle color={props.color} onClick={props.onClick}>
      <svg width="44" height="25" viewBox="0 0 44 25" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.044632 15.7184L5.20182 10.5612C5.42801 10.335 5.78992 10.335 6.01611 10.5612C6.2423 10.7874 6.2423 11.1493 6.01611 11.3755L1.67322 15.7184L5.97087 20.016C6.19706 20.2422 6.19706 20.6041 5.97087 20.8303C5.74468 21.0565 5.38277 21.0565 5.15658 20.8303L0.044632 15.7184Z" />
        <path d="M25.5078 13.6534C25.5653 12.1563 26.5252 10.8618 27.9565 10.3665C28.3416 10.2371 28.7325 10.1639 29.1349 10.1583C29.4165 10.1527 29.6292 10.344 29.6292 10.5973C29.6292 10.8506 29.4223 11.0363 29.1406 11.0419C27.945 11.0644 26.9333 11.7792 26.5539 12.8993C26.4677 13.1582 26.4505 13.4508 26.416 13.7266C26.393 13.8955 26.3413 14.0362 26.1918 14.1262C25.8986 14.3007 25.5308 14.1037 25.5135 13.766C25.5078 13.7322 25.5078 13.6928 25.5078 13.6534Z" />
        <path d="M43.7581 8.93129C43.7581 8.55983 43.7064 8.23901 43.5972 7.95197C43.2868 7.14713 42.712 6.62933 41.8957 6.42108C41.5278 6.3254 41.1427 6.26912 40.7633 6.20721C40.6426 6.19032 40.5219 6.16781 40.407 6.15092C39.5332 6.00459 38.6538 5.86951 37.8318 5.74006C37.6191 5.70629 37.4811 5.59935 37.4064 5.40799C37.2742 5.08155 37.1362 4.74948 37.004 4.42304C36.7684 3.84896 36.5212 3.25236 36.297 2.66139C35.8716 1.54699 34.9347 0.910995 33.7103 0.910995L33.6873 0.910995C31.6065 0.922252 29.4854 0.922252 27.4333 0.916624C26.5654 0.916624 25.7031 0.916624 24.8352 0.916624C24.8122 0.916624 24.7834 0.916624 24.7604 0.916624C24.7374 0.916624 24.7144 0.916624 24.6915 0.916624C24.6455 0.916624 24.5995 0.916624 24.5535 0.922252C23.5188 1.00668 22.8003 1.47945 22.4094 2.32369C22.0415 3.11728 21.7139 3.94464 21.3978 4.74948C21.3173 4.9521 21.2368 5.15472 21.1563 5.35734C21.0586 5.59372 20.8977 5.71755 20.6332 5.75694C20.2424 5.81323 19.8457 5.88077 19.4664 5.94268C19.3399 5.96519 19.2192 5.98207 19.0985 6.00459L18.7593 6.06087C18.3397 6.12841 17.9086 6.19595 17.489 6.26912C17.4143 6.28037 17.3395 6.29163 17.2648 6.30851C17.0234 6.34791 16.7935 6.38168 16.575 6.44922C15.4944 6.77003 14.7931 7.70433 14.7874 8.82998C14.7874 12.0381 14.7874 15.3081 14.7874 18.4712C14.7874 19.7488 14.7874 21.0321 14.7874 22.3097C14.7874 22.6643 14.8678 23.0076 15.0288 23.3228C15.5116 24.274 16.2934 24.758 17.3568 24.7636C20.2251 24.7749 23.1394 24.7693 25.9561 24.7693C27.0597 24.7693 28.1633 24.7693 29.267 24.7693L31.6237 24.7693C34.745 24.7693 37.9755 24.7693 41.1485 24.7636C41.4359 24.7636 41.7233 24.7242 41.9705 24.6454C43.0339 24.3246 43.7466 23.3566 43.7466 22.2422L43.7466 21.0208C43.7524 17.0585 43.7524 12.9611 43.7581 8.93129ZM42.0509 23.0752C41.821 23.3003 41.5049 23.4297 41.183 23.4297C38.1652 23.4241 35.0956 23.4241 32.1238 23.4241C31.1754 23.4241 30.2212 23.4241 29.2727 23.4241L26.5251 23.4241C23.4728 23.4241 20.4148 23.4241 17.3625 23.4241C16.7992 23.4241 16.3738 23.1258 16.2072 22.608C16.1784 22.5236 16.1669 22.4223 16.1669 22.3041C16.1669 17.4919 16.1669 13.0681 16.1669 8.78496C16.1669 8.20524 16.5865 7.74373 17.1958 7.65367C17.535 7.60302 17.8741 7.54674 18.2075 7.49045C18.3857 7.46231 18.5639 7.42854 18.7478 7.4004C19.018 7.35537 19.2939 7.31035 19.5641 7.27095C19.8055 7.23155 20.0527 7.19215 20.2941 7.15276C20.4493 7.12462 20.6103 7.09647 20.7655 7.07396C21.1161 7.01205 21.484 6.95014 21.8461 6.90511C21.9783 6.88823 22.0186 6.86009 22.0875 6.68561C22.3519 6.0271 22.6221 5.36296 22.8865 4.71571C23.105 4.18665 23.3234 3.64071 23.5418 3.1004C23.6568 2.81898 23.8637 2.43063 24.3638 2.28992C24.4558 2.26178 24.565 2.25053 24.6685 2.25053C27.9852 2.25053 31.0029 2.25053 33.8943 2.25053C34.5381 2.25053 34.86 2.71204 35.0152 3.1004C35.2796 3.7589 35.5555 4.42867 35.8199 5.07029C36.0613 5.66689 36.3085 6.26349 36.5499 6.86571C36.5557 6.86571 36.5614 6.86571 36.5729 6.87134C36.9178 6.92763 37.2685 6.98391 37.6076 7.04019C37.7858 7.06833 37.964 7.09647 38.1422 7.13024C38.3951 7.16964 38.648 7.21467 38.9067 7.25407C39.1653 7.29346 39.424 7.33849 39.6884 7.37789L39.8034 7.39477C40.2747 7.47357 40.7691 7.55236 41.2462 7.63679L41.2979 7.64804C41.4359 7.67056 41.5911 7.6987 41.7348 7.76624C42.1659 7.97448 42.3958 8.34032 42.3901 8.82998C42.3901 11.5766 42.3901 14.3176 42.3901 17.0642L42.3901 19.5631C42.3901 19.8276 42.3901 20.0922 42.3901 20.3623C42.3901 20.9814 42.3843 21.6231 42.3958 22.2478C42.3958 22.5574 42.2751 22.85 42.0509 23.0752Z" />
        <path d="M34.3196 9.27466C32.986 7.95764 31.2041 7.23159 29.2957 7.22596L29.267 7.22596C27.3701 7.22596 25.5881 7.94076 24.2546 9.24089C22.9095 10.5467 22.1622 12.297 22.1565 14.1656C22.1507 16.0342 22.875 17.7903 24.2143 19.1073C25.5479 20.4243 27.3356 21.156 29.2497 21.1616C29.2612 21.1616 29.267 21.1616 29.2785 21.1616C31.1754 21.1616 32.9515 20.4468 34.2851 19.1467C35.6302 17.8409 36.3775 16.0849 36.3947 14.2107C36.3832 12.3421 35.6474 10.5917 34.3196 9.27466ZM33.3137 18.2011C32.233 19.248 30.8017 19.8277 29.29 19.8277L29.2325 19.8277C27.7207 19.8277 26.2952 19.2423 25.2088 18.1842C24.1109 17.1149 23.5073 15.6909 23.5131 14.1769C23.5131 12.6798 24.1224 11.2671 25.2203 10.1977C26.3067 9.13958 27.7495 8.55424 29.2785 8.55424L29.2957 8.55424C30.819 8.55987 32.256 9.14521 33.3424 10.209C34.4403 11.284 35.0381 12.7079 35.0324 14.2219C35.0209 15.7247 34.4116 17.1374 33.3137 18.2011Z" />
      </svg>
    </CameraBackStyle>
  );
};

export const CameraBackStyle = styled.svg`
  width: 50px;
  height: 50px;
  margin-left: 15px;
  fill: ${(props) => props.color};
`;

export const GalleryBack = (props) => {
  return (
    <GalleryBackStyle color={props.color} onClick={props.onClick}>
      <svg width="52" height="27" viewBox="0 0 52 27" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.0066 0.951292C38.8346 0.951292 43.6698 0.951292 48.4978 0.951291C50.0735 0.951291 51.2823 1.91143 51.5917 3.39076C51.6421 3.63257 51.6493 3.88861 51.6493 4.13042C51.6493 10.6025 51.6565 17.0674 51.6493 23.5394C51.6493 25.4526 50.3614 26.7257 48.4258 26.7257C38.813 26.7257 29.193 26.7257 19.5801 26.7257C17.6446 26.7257 16.3567 25.4526 16.3567 23.5395C16.3567 17.0816 16.3711 10.6238 16.3423 4.16598C16.3423 2.45196 17.5007 1.25 18.8318 1.00819C19.1125 0.958406 19.4075 0.951294 19.6881 0.951294C24.4657 0.951293 29.2361 0.951293 34.0066 0.951292ZM33.9994 25.225C38.7986 25.225 43.5906 25.225 48.3899 25.225C49.5123 25.225 50.1239 24.6205 50.1239 23.5181C50.1239 17.0674 50.1239 10.6238 50.1239 4.17309C50.1239 3.0636 49.5123 2.46618 48.3899 2.46618C38.8202 2.46618 29.2505 2.46618 19.6809 2.46618C18.4793 2.46618 17.8893 3.04226 17.8893 4.22999C17.8893 10.6523 17.8893 17.0816 17.8893 23.5039C17.8893 24.6347 18.4937 25.2321 19.6449 25.2321C24.4297 25.225 29.2146 25.225 33.9994 25.225Z" />
        <path d="M38.6495 18.881C39.0093 18.5041 39.3474 18.1413 39.6928 17.7929C40.4195 17.0532 41.1606 16.3278 41.8874 15.5881C42.1824 15.2894 42.6932 15.2823 42.9882 15.5739C44.7367 17.3163 46.4851 19.0517 48.2336 20.7942C48.3127 20.8724 48.3918 20.9435 48.4494 21.0289C48.6581 21.3276 48.6149 21.7188 48.3487 21.9677C48.104 22.2024 47.7083 22.2451 47.4205 22.053C47.3126 21.9819 47.219 21.8823 47.1255 21.7899C45.5713 20.2537 44.0243 18.7245 42.4918 17.2025C41.5708 18.1271 40.657 19.0375 39.7288 19.9692C40.5059 20.7373 41.3333 21.5623 42.168 22.3802C42.4054 22.6149 42.5205 22.9065 42.3766 23.1839C42.2687 23.3901 42.0313 23.6106 41.8154 23.6533C41.5995 23.6959 41.2973 23.575 41.1175 23.4186C40.6642 23.0345 40.2612 22.5936 39.8367 22.1739C36.714 19.0873 33.5984 16.0077 30.4757 12.921C30.375 12.8215 30.303 12.6934 30.1447 12.4872C30.008 12.6792 29.9505 12.8001 29.8569 12.8926C26.8637 15.8512 23.8705 18.8099 20.8773 21.7685C20.7765 21.8681 20.6758 21.9748 20.5607 22.053C20.2585 22.2522 19.8556 22.1953 19.6109 21.9392C19.3663 21.6832 19.3375 21.3134 19.539 21.0218C19.6181 20.908 19.726 20.8084 19.8268 20.7088C22.9711 17.6008 26.1298 14.507 29.2525 11.3706C29.972 10.6523 30.3174 10.638 31.0585 11.3777C33.4473 13.7958 35.8793 16.1642 38.2969 18.5539C38.4121 18.6605 38.5056 18.7459 38.6495 18.881Z" />
        <path d="M40.9162 6.99657C40.9234 8.66792 39.5635 10.0263 37.8726 10.0477C36.1746 10.069 34.7859 8.69637 34.7859 7.00368C34.7859 5.32522 36.153 3.97391 37.8439 3.9668C39.5276 3.97391 40.909 5.33233 40.9162 6.99657ZM37.8439 8.52568C38.6929 8.52568 39.3836 7.85003 39.3836 7.01791C39.3836 6.18578 38.6929 5.51013 37.8439 5.51013C36.9948 5.51013 36.3113 6.17867 36.3113 7.01791C36.3113 7.85003 36.9948 8.52568 37.8439 8.52568Z" />
        <path d="M9.10937e-09 17.2515L6.05245 11.1991C6.31791 10.9336 6.74264 10.9336 7.0081 11.1991C7.27356 11.4646 7.27356 11.8893 7.0081 12.1547L1.9113 17.2515L6.95501 22.2953C7.22047 22.5607 7.22047 22.9854 6.95501 23.2509C6.68955 23.5164 6.26482 23.5164 5.99936 23.2509L9.10937e-09 17.2515Z" />
      </svg>
    </GalleryBackStyle>
  );
};

export const GalleryBackStyle = styled.svg`
  width: 55px;
  height: 50px;
  margin-left: 15px;
  fill: ${(props) => props.color};
`;

export const RemoveImg = ({ colors, disabled = false, onClick }) => {
  return (
    <RemoveImgStyle colors={colors} onClick={disabled ? null : onClick}>
      <svg width="42" height="42" viewBox="0 0 47 47" xmlns="http://www.w3.org/2000/svg">
        <circle cx="23.5" cy="23.5" r="23" fill={colors.backgroundColor || "white"} stroke={colors.generalTextColor || "#858585"} />
        <path d="M15.5024 16.431C14.9833 16.431 14.4947 16.431 14 16.431C14 15.9357 14 15.4655 14 14.9702C15.9544 14.9702 17.9026 14.9702 19.9058 14.9702C19.9058 14.7006 19.9058 14.4687 19.9058 14.2304C19.9119 12.9765 20.8525 12.011 22.0739 12.0047C23.0328 11.9984 23.9855 11.9984 24.9444 12.0047C26.1475 12.011 27.0881 12.9828 27.1003 14.2116C27.1003 14.4373 27.1003 14.6693 27.1003 14.9451C29.073 14.9451 31.0273 14.9451 33 14.9451C33 15.4592 33 15.9232 33 16.431C32.5114 16.431 32.0167 16.431 31.4976 16.431C31.4304 17.2586 31.3693 18.0486 31.3083 18.8386C31.1739 20.6191 31.0334 22.3997 30.8991 24.1803C30.7708 25.9107 30.6426 27.6348 30.5082 29.3652C30.3922 30.895 30.2883 32.4248 30.1418 33.9545C30.0318 35.1019 29.0424 35.9984 27.9187 36.0047C24.9688 36.011 22.019 36.011 19.063 36.0047C17.9759 36.0047 16.956 35.0893 16.8399 33.9734C16.7117 32.7257 16.6323 31.4781 16.5346 30.2304C16.3941 28.4436 16.2597 26.6505 16.1254 24.8574C15.9971 23.127 15.8689 21.4028 15.7345 19.6724C15.6734 18.6066 15.5879 17.5408 15.5024 16.431ZM16.956 16.4498C16.9621 16.6254 16.9682 16.7759 16.9804 16.9201C17.1148 18.6693 17.2491 20.4185 17.3835 22.1677C17.5178 23.9044 17.64 25.6411 17.7743 27.384C17.927 29.4216 18.0919 31.4655 18.2385 33.5031C18.2874 34.1928 18.6049 34.5313 19.2829 34.5313C22.1045 34.5313 24.92 34.5313 27.7416 34.5313C28.4195 34.5313 28.7248 34.2179 28.7676 33.5345C28.8897 31.8041 29.018 30.0799 29.1524 28.3495C29.2867 26.6003 29.4211 24.8511 29.5554 23.1082C29.6959 21.3088 29.8303 19.5094 29.9646 17.71C29.9952 17.3025 30.0196 16.8887 30.044 16.4624C25.6651 16.4498 21.3349 16.4498 16.956 16.4498ZM25.7628 14.9389C25.7628 14.6818 25.7689 14.4436 25.7628 14.2053C25.7445 13.7288 25.4452 13.384 24.981 13.3777C23.9978 13.3589 23.0084 13.3652 22.0251 13.3777C21.6037 13.384 21.2922 13.6787 21.2494 14.0799C21.2189 14.3558 21.2433 14.6379 21.2433 14.9389C22.758 14.9389 24.242 14.9389 25.7628 14.9389Z" />
        <path d="M19.8691 19.4835C20.3394 19.4835 20.7974 19.4835 21.2677 19.4835C21.2677 23.4772 21.2677 27.4647 21.2677 31.4584C20.8035 31.4584 20.3455 31.4584 19.8691 31.4584C19.8691 27.4835 19.8691 23.5023 19.8691 19.4835Z" />
        <path d="M24.2053 31.4647C23.7412 31.4647 23.2892 31.4647 22.8068 31.4647C22.8068 27.4835 22.8068 23.5023 22.8068 19.496C23.2587 19.496 23.7229 19.496 24.2053 19.496C24.2053 23.4835 24.2053 27.4647 24.2053 31.4647Z" />
        <path d="M25.7321 19.4898C26.2024 19.4898 26.6544 19.4898 27.1307 19.4898C27.1307 23.4772 27.1307 27.4584 27.1307 31.4584C26.6727 31.4584 26.2085 31.4584 25.7321 31.4584C25.7321 27.4709 25.7321 23.4898 25.7321 19.4898Z" />
      </svg>
    </RemoveImgStyle>
  );
};

export const ColorChange = ({ colors, disabled = false, onClick }) => {
  return (
    <ActionBtnStyle onClick={disabled ? null : onClick}>
      <svg viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="23.5" cy="23.5" r="23" fill={colors.backgroundColor} stroke={colors.generalTextColor} />
        <path d="M23 42.4935C12.7377 42.2284 4.5 33.8262 4.5 23.5C4.5 13.1738 12.7377 4.77156 23 4.50645V42.4935Z" fill="black" stroke="white" />
        <path d="M24.5 4.50645C34.7623 4.77156 43 13.1738 43 23.5C43 33.8262 34.7623 42.2284 24.5 42.4935L24.5 4.50645Z" fill="white" stroke="white" />
      </svg>
    </ActionBtnStyle>
  );
};

export function TextChange({ colors, disabled = false, onClick, textClicks }) {
  const abc = "abcdefghijklmnopqrstuvwxyz".toUpperCase();

  return (
    <ActionBtnStyle onClick={disabled ? null : onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="17 14 47 47"
        //
        fill="none"
        stroke={colors.generalTextColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="40.5" cy="37.5" r="23" fill={colors.backgroundColor} />
        <path d="M35 27L31.5 23L28 27" />
        <path d="M28 49L31.5 53L35 49" />
        <path d="M31.5 24L31.5 52.5" />
        <path d="M40 34L55 34" />
        <path d="M40 28L50 28" />
        <path d="M40 50L50 50" />

        <text x="40" y="46" fill={colors.generalTextColor} stroke="none" style={{ fontSize: 12 }}>
          {abc[textClicks] || textClicks}
        </text>
      </svg>
    </ActionBtnStyle>
  );
}

export const TextHowTo = ({ colors, doubleTapText }) => {
  const { generalTextColor } = colors;
  return (
    <TextHowToStyle>
      <svg width="34" height="38" viewBox="0 0 34 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 37C1 33.2722 6.60862 23.9193 11.0526 19.6495C15.4966 15.3797 18.3802 13.0346 29 8" stroke={generalTextColor} strokeLinecap="round" />
        <path
          d="M23.4835 22.0557C25.4236 17.8358 27.6851 14.554 30.4034 10.9418C31.2959 9.75585 32.2062 8.61987 32.7772 7.1888C33.2548 5.99187 31.4304 6.30078 31.0232 6.25644C26.8566 5.80283 22.691 5.30095 18.5493 4.75908"
          stroke={generalTextColor}
          strokeLinecap="round"
        />
      </svg>
      <div>
        <Phrase Key={doubleTapText.translationKey} default={doubleTapText.text || ""} />
      </div>
    </TextHowToStyle>
  );
};

const TextHowToStyle = styled.div`
  position: absolute;
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  margin-left: -10px;
  svg {
    width: 23px;
    height: 23px;
  }
  @media ${device.mobileS} {
    top: 48%;
  }
  @media ${device.mobileM} {
    top: 49%;
  }
  @media ${device.mobileL} {
    top: 50%;
    svg {
      width: 25px;
      height: 25px;
    }
  }
`;

export const RemoveImgStyle = styled.svg`
  position:absolute;
  right: 10px;
  top: 60%;
  width: 42px;
  height: 42px;
  fill:${(props) => (props.colors ? props.colors.generalTextColor : "black")}
  :focus {
    fill:${(props) => (props.colors ? props.colors.generalTextColor : "black")}
  }
`;

export const AddImg = (props) => {
  return (
    <AddImgStyle colors={props.colors} onClick={props.onClick}>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4047 21.463L10.405 1.57836C10.405 0.961892 10.9045 0.462354 11.521 0.462354C12.1375 0.462354 12.637 0.961892 12.637 1.57836L12.637 21.4633C12.637 22.0797 12.1375 22.5793 11.521 22.5793C10.9045 22.5793 10.4047 22.0795 10.4047 21.463Z" />
        <path d="M1.57857 10.4048H21.4634C22.0799 10.4048 22.5794 10.9043 22.5794 11.5208C22.5794 12.1373 22.0799 12.6368 21.4634 12.6368L1.57834 12.6366C0.962091 12.6368 0.462303 12.1371 0.462542 11.5208C0.462303 10.9046 0.96209 10.4048 1.57857 10.4048Z" />
      </svg>
    </AddImgStyle>
  );
};

export const AddImgStyle = styled.svg`
  fill: ${(props) => (props.colors ? props.colors.generalTextColor : "black")};
`;

export const AddImgWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  user-select: none;
  flex-direction: row;
  font-family: ${(props) => props.style.FontFamily};
  font-size: ${(props) => props.style.FontSize};
  color: ${(props) => props.style.color};
`;

export const AddImgBorderContainer = styled.div`
  display: flex;
  justify-contet: center;
  align-items: center;
  border: 1px solid ${props => props.borderColor || 'black'};
  color: ${props => props.textColor || 'black'};
  border-radius: 25px;
  padding: 10px 18px;
  width: 67.5%;
    
  svg {
    margin-right: 15px;
  }
  `

export const LogoHeaderSpan = styled.div`
  display: flex;
  flex: ${(props) => props.data.position};
  flex-direction: column;
  justify-content: flex-end;
`;

export const LogoWrapper = styled.div`
  width: ${(props) => props.data.width};
  height: ${(props) => props.data.height};
  align-self: flex-start;
`;

export const EditText = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 95%;
  flex-direction: column;
  font-family: ${(props) => props.style.FontFamily};
  font-size: ${(props) => props.style.FontSize};
  color: ${(props) => props.style.color};
  margin-left: 10px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  ${({ titleHeight }) => titleHeight && `height: ${titleHeight}px;`}
  justify-content: center;
`;

export const EditTextTitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 64px 1fr 64px;
  grid-template-areas: "headerLeft headerCenter headerRight";
  width: 100%;
`;

export const NewTitle = styled.div`
  align-self: center;
  color: ${(props) => props.colors.generalTextColor};
  opacity: 0.6;
  display: flex;
  width: 80%;
  justify-content: center;
`;

export const EditImg = styled.div`
  align-self: center;
  font-family: ${(props) => props.style.FontFamily};
  font-size: ${(props) => props.style.FontSize};
  color: ${(props) => props.style.color};
`;

export const MovePhoto = styled.div`
  align-self: left;
  font-family: ${(props) => props.style.FontFamily};
  color: ${(props) => props.style.color};
  padding-bottom: 5px;
  margin-left: 5px;

  @media ${device.mobileS} {
    margin-top: 10px;
    font-size: 18px;
  }
  @media ${device.mobileM} {
    margin-top: 27px;
    font-size: 22px;
  }
  @media ${device.mobileL} {
    margin-top: 37px;
    font-size: 23px;
  }
`;

export const EditInstruction = styled(MovePhoto)``;

export const TextStyleChangeHelper = styled.div`
  align-self: center;
  font-family: ${(props) => props.style.FontFamily};
  font-size: 18px;
  color: ${(props) => props.style.color};
  margin-top: 5px;
`;

export const EditContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 25;
  height: ${() => editContainerHeight()}px;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    height: ${() => editContainerHeight({ printButton: 13 })}px;
  }
  background-color: ${({ colors }) => (colors && colors.backgroundColor) || "#fff"};
`;

export const DetailsWrapper = styled.div`
  height: ${() => window.innerHeight * 0.35}px;
  display: block;
`;

export const PrintText = styled.p`
  font-family: "MuktaRegular";
  font-size: 16px;
  color: ${(props) => props.color};
  z-index: 22;
`;

export const PrintCancel = styled.p`
  font-family: "MuktaRegular";
  position: relative;
  top: 64%;
  width: 100%;
  text-align: center;
  font-size: 22px;
  font-weight: bolder;
  text-decoration: underline;
  color: black;
`;

export const PrintWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  z-index: 20;
  height: 10%;
`;

export const PrintSurpriseMeWrap = styled(PrintWrap)`
  padding-top: 15%;
`;

const getFontSize = (size) => {
  switch (size) {
    case "22px":
      return { size: "1em", height: "45px" };
    case "26px":
      return { size: "1.2em", height: "50px" };
    case "35px":
      return { size: "1.4em", height: "55px" };
    default:
      return { size: "1em", height: "45px" };
  }
};

export const PrintButton = styled.div`
  margin-top: 0px;
  width: 220px;
  min-height: ${({ data }) => getFontSize(data.FontSize).height || "45px"};
  max-height: max-content;
  font-size: ${({ data }) => getFontSize(data.FontSize).size || "1em"};
  font-weight: ${({ data }) => data.FontWeight};
  font-family: ${({ data }) => data.FontFamily};
  color: ${({ data }) => data.color};
  border: 1px solid ${({ data }) => data.backgroundColor || "#DCDCDC"};
  text-align: center;
  align-self: center;
  background-color: ${({ data }) => data.backgroundColor};
  border-radius: 25px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const EditButton = styled(PrintButton)`
  width: 30%;
`;
export const EditButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  font-size: 18px;
`;

export const DoneButton = styled(PrintButton)`
  @media ${device.mobileXS} {
    bottom: 20%;
  }
  @media ${device.mobileS} {
    bottom: 28%;
  }
  @media ${device.mobileM} {
    bottom: 28%;
  }
  @media ${device.mobileL} {
    bottom: 28%;
  }
`;

export const PrintSurpriseMe = styled(PrintButton)`
  font-family: "MuktaMedium";
  text-transform: uppercase;
  font-size: 18px;
`;
export const DesignButton = styled(PrintButton)`
  font-family: "MuktaMedium";
  text-transform: uppercase;
  font-size: 18px;
`;

export const SpinWrapper = styled.div`
  width: 120px;
  height: 20px;
  align-self: center;
  background-color: ${(props) => props.color};
  border-radius: 25px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const PrintAnother = styled.p`
  width: 220px;
  height: 51px;
  font-size: 20px;
  bottom: 400px;
  color: white;
  text-align: center;
  align-self: center;
  background-color: ${(props) => props.color};
  border-radius: 25px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: absolute;
`;

export const ULineBtn = styled.div`
  display: flex;
  justify-content: center;
  color: ${(props) => props.style.color};
  font-family: ${(props) => props.style.FontFamily};
  font-weight: ${(props) => props.style.FontWeight};
  font-size: ${(props) => props.style.FontSize};
  text-decoration: underline;
  padding-top: 8px;
`;
export const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-left: 20px;
  margin-right: 20px;
`;
export const FilterTab = styled.button`
  width: ${getNavigatorLanguage() !== "en" ? "100px" : "85px"};
  max-width: 100px;
  height: 82px;
  max-height: 82px;
  border: 1px solid ${(props) => (props.data && !props.isActive ? props.data.borderColor : props.data.selectedBorderColor)};
  border-radius: 16px;
  background: ${(props) => (props.data ? props.data.backgroundColor : "white")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  :focus {
    outline: none;
  }
  color: ${(props) => (props.data ? props.data.textColor : "black")};
`;

export const FilterTabText = styled.div`
  font-family: "MuktaRegular";
  font-size: 16px;
`;

export const TextFontsTabs = styled.div`
  display: flex;
  justify-content: ${(props) => (props.size > 3 ? "start" : "center")}
  width: 100%;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FilterSelectionTabs = styled(TextFontsTabs)``;

export const FrameTabs = styled.div`
  display: ${(props) => (props.disabled ? "none" : "flex")};
  justify-content: ${(props) => (props.size > 3 ? "start" : "center")}
  width: 100%;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FrameTab = ({ data, disabled, isActive, src, onClick, customFrameType, colors, index }) => {
  return (
    <EditSelectionWrapper>
      <EditSelection colors={colors} isActive={isActive} hasText={index === 0} onClick={onClick}>
        <ImageWrapper size={"80"}>
          <img alt={"frame-tab"} style={{ width: "inherit", height: "inherit" }} src={src ? src : `/customFrames/${customFrameType}.svg`} />
        </ImageWrapper>
      </EditSelection>
      {index === 0 && (
        <FilterText colors={colors} isActive={true}>
          <XSText id={"text"}>
            <Phrase Key={"3d8aa0fb-0a33-4b2e-942a-8da7acb24dd9"} default={"Default"} />
          </XSText>
        </FilterText>
      )}
    </EditSelectionWrapper>
  );
};

export const EditSelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HelpContnetStyle = styled.div`
  width: 95%;
  height: 100%;
  border-radius: 15px 0px 0px 15px;
  background-color: white;
  color: ${({ color }) => color || "#000"};
`;

export const HelpContnetTitleStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  text-align: center;
  height: fit-content;
`;

export const HelpContnetBodyStyle = styled(HelpContnetTitleStyle)`
  height: fit-content;
  align-items: center;
`;

export const HelpContnetBodyRowStyle = styled.div`
  display: flex;
  padding-top: 9%;
  padding-bottom: 5%;
  padding-left: 5%;
  padding-right: 3%;
  width: 276px;
  justify-content: ${({ justify }) => justify || "none"} @media ${device.mobileXS} {
    padding-top: 4%;
  }
  @media ${device.mobileS} {
    padding-top: 5%;
  }
  @media ${device.mobileM} {
    padding-top: 9%;
  }
  @media ${device.mobileL} {
    padding-top: 9%;
  }
`;

export const HelpContnetDividerStyle = styled.div`
  display: flex;
  align-self: center;
  border: ${({ color }) => (color ? `1px solid ${color}` : "1px solid #cdcdcd")};
  width: 80%;
`;

export const HelpContnetBodyIconStyle = styled.div`
  padding-right: 12px;
`;

export const TextTab = styled.img`
  background-image: url(${(props) => props.src});
  background-size: ${(props) => (props.size ? props.size : "cover")}  
  width: 80px;
  height: 80px;
  border-radius: 14px;
`;
export const EditSelection = styled.div`
  align-items: center;
  overflow: hidden;
  justify-content: center;
  display: flex;
  align-content: center;
  width: 95px;
  height: 95px;
  border-radius: 14px;
  border: ${(props) => (props.colors && !props.isActive ? "transparent" : `2px solid ${props.colors.generalTextColor}`)};
  box-sizing: border-box;
`;
export const FilterText = styled.div`
  display: flex;
  justify-content: center;
  #text {
    background-color: ${({ colors, isActive }) => (colors && !isActive ? "transparent" : `${colors.backgroundColor}`)};
    width: max-content;
    min-width: 75px;
    margin-top: -7px;
  }
`;
export const FieldSetBorder = styled.fieldset`
  width: 90px;
  height: 2px;
  border: 2px solid transparent;
  border-top-color: black;
  box-sizing: border-box;
`;
export const ImageWrapper = styled.div`
  background-size: cover;
  background-color: white;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid #dcdcdc;
`;

export const CropStyle = styled.div`
  width: ${(props) => props.width}
  hieght: ${(props) => props.hieght}
  transform: translate(-50%,-50%);
  box-sizing: border-box;
  box-shadow: 0 0 0 9999em;
  color: rgb(255,255,255,0.8);
  overflow: hidden;
  border-radius: 50%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin: 6px;
`;

export const ColorButton = styled.button`
  width: 30px;
  max-width: 60px;
  height: 30px;
  margin: 5px;
  max-height: 60px;
  border: 1px solid ${(props) => (props.data && !props.isActive ? "#AAAAAA" : props.data.selectedBorderColor)};
  border-radius: 30px;
  background: ${(props) => (props.color ? props.color : "white")};
  display: flex;
  align-self: flex-end;
  :focus {
    outline: none;
  }

  color: ${(props) => (props.data ? props.data.textColor : "black")};
`;

export const TextArea = styled.textarea`
z-index: 1001;
font-size: 25px;
text-align: center;
border-width: 0;
outline: none;
max-height: 80px;
background: ${(props) => props.colors.backgroundColor || 'white'};
color: ${(props) => props.colors.generalTextColor || 'white'};
&::placeholder {
  color: ${(props) => props.colors.generalTextColor || 'white'};
  opacity: 0.6
}
`